import { ArrowRight } from "lucide-react";
import PhoneMockup from "./PhoneMockup";
import { AppStoreButton, PlayStoreButton } from "./StoreButtons";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 px-6 lg:px-10 overflow-hidden"
    >
      {/* Background grid */}
      <div className="absolute inset-0 grid-pattern opacity-40 [mask-image:radial-gradient(ellipse_at_center,black_30%,transparent_75%)]" />

      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 lg:gap-12 items-center relative">
        {/* Left: Content */}
        <div className="flex flex-col gap-8 max-w-xl">
          <div
            className="animate-fadeUp inline-flex items-center gap-2 self-start text-xs font-medium px-3 py-1.5 rounded-full bg-neutral-100 border border-neutral-200 text-neutral-700"
            data-testid="hero-badge"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-violet-500 animate-pulseGlow" />
            Propulsé par l'IA
          </div>

          <h1
            data-testid="hero-title"
            className="animate-fadeUp delay-100 text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05] text-neutral-950"
          >
            Ton physique.<br />
            Analysé par l'<span className="text-violet-600">IA</span>.<br />
            Amélioré par toi.
          </h1>

          <p
            data-testid="hero-subtitle"
            className="animate-fadeUp delay-200 text-lg text-neutral-600 leading-relaxed max-w-md"
          >
            Scanne ton corps, reçois des feedbacks précis et un programme de
            musculation sur-mesure pour atteindre tes objectifs.
          </p>

          <div
            id="telecharger"
            className="animate-fadeUp delay-300 flex flex-col sm:flex-row items-start sm:items-center gap-3 pt-2"
          >
            <AppStoreButton variant="dark" testId="app-store-button" />
            <PlayStoreButton variant="dark" testId="play-store-button" />
          </div>

          <a
            href="#fonctionnalites"
            data-testid="hero-secondary-link"
            className="animate-fadeUp delay-400 inline-flex items-center gap-1.5 text-sm text-neutral-600 hover:text-violet-600 transition-colors group"
          >
            Découvrir comment ça marche
            <ArrowRight
              size={14}
              className="group-hover:translate-x-1 transition-transform"
            />
          </a>
        </div>

        {/* Right: Phone mockup */}
        <div className="flex justify-center lg:justify-end animate-fadeUp delay-200">
          <PhoneMockup />
        </div>
      </div>
    </section>
  );
}
